import scrollBar from './ScrollBar.js';

class Modal {

  constructor() {
    // this.modal = document.getElementById(modalId);
    // console.log('modal');
  }

  prepareAll(excludedModals) {
    const modals = document.querySelectorAll('.modal');
    modals.forEach((modal) => {
      if (excludedModals.indexOf(modal.id) === -1) {
        this.prepareModal(modal)
      }
    })

    const triggers = document.querySelectorAll('[data-modal="modal"][data-target]');    
    triggers.forEach((trigger) => {
      if (trigger.dataset.target.startsWith('#') &&
        (excludedModals.indexOf(trigger.dataset.target.substring(1)) !== -1)) {
          return
      }
      this.prepareTrigger(trigger)        
    })
  }

  
  prepareTrigger(trigger) {
    const modalSelector = trigger.getAttribute('data-target');
    const node = document.querySelector(modalSelector);
    if (this.isModal(node)) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();	  
        this.openModal(node);
      });
    }
  }

  prepareModal(modal) {

    // hiding modal by Close button (data-dismiss="modal") click 
    const closeButtons = modal.querySelectorAll('[data-dismiss]');
    closeButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal(modal);
      })
    })

    // hiding modal by ESC
    document.addEventListener('keydown', (e) => {
        if (e.keyCode == 27) {
          if (this.isModalVisible(modal)) {
            this.closeModal(modal);
            e.preventDefault();	
            return;
          }
        }
    });

    // hiding modal by clicking outside (overlay)
    // modal.addEventListener('click', (e) => {
    //   if (this.isModalVisible(modal)) {            
    //       this.closeModal(modal);
    //       return;
    //   }
    // });

    // clicking inside modal do not force modal hiding
    // for (let i = 0; i < modal.childNodes.length; i++) {
    //   modal.childNodes[i].addEventListener('click', function (e) {
    //     e.stopPropagation();
    //   });
    // }    



    // hiding modal by clicking outside (overlay)
    const modalInner = modal.firstElementChild;
    let mouseDownWasFired = false;
    
    modal.addEventListener('click', (e) => {
      // console.log('modal click ', e.target);
      if (!mouseDownWasFired) {
        // if (e.target !== modal && !element.contains(e.target)) {
        
        if (!this.isModalVisible(modal)) return;        
        
        if (e.target !== modal) return;

        this.closeModal(modal);
        return;
      }
      else {
        // console.log('modal click cancelled');
        mouseDownWasFired = false;
      }
    });

    modalInner.addEventListener('mousedown', (e) => {
      // e.stopPropagation();
      mouseDownWasFired = true;
      // console.log('inner mousedown', e.target);
    });


  }


  // returns true, if node is modal
  isModal(node) {
    return (node && node.classList.contains('modal'));
}

  // returns true, if modal is opened
  isModalVisible(modal) {
      return modal.classList.contains('modal--visible');
  }

  // close modal
  closeModal(modal) {
    // console.log('closemodal ',this);
    // document.body.style.margin = '';
    // document.body.style.overflow = '';
    scrollBar.show();
    modal.classList.remove('modal--visible');
    // console.log('modal.dispatchEvent(this.afterHideEvent);');
    // modal.dispatchEvent(this.afterHideEvent);
    // console.log('---------', window.alsagor.afterHideEvent);
    // document.dispatchEvent(window.alsagor.afterHideEvent);
  }
  
  // open modal
  openModal(modal) {
    // console.log('openmodal ', this);
    // const scrollBarWidth = window.innerWidth - document.body.offsetWidth;
    // document.body.style.margin = '0px ' + scrollBarWidth + 'px 0px 0px';
    // document.body.style.overflow = 'hidden';
    scrollBar.hide();
    modal.classList.add('modal--visible');
    // console.log('modal.dispatchEvent(this.afterShowEvent);');
    // console.log('---------', window.alsagor.afterShowEvent);
    // document.dispatchEvent(window.alsagor.afterShowEvent);
    // modal.dispatchEvent(this.afterShowEvent);    
  }
}


export default Modal;







/*

https://stackoverflow.com/questions/10476632/how-to-scroll-the-page-when-a-modal-dialog-is-longer-than-the-screen
https://jsfiddle.net/0x0049/koodkcng/


function openModal($modal) {
  // Note: fixed elements will also need the margin 
  // adjustment (like a fixed header, if you have one).
  var scrollBarWidth = window.innerWidth - document.body.offsetWidth;
  $('body')
    .css('margin-right', scrollBarWidth)
    .addClass('showing-modal');
  $modal.show();
};

function closeModal($modal) {
    $('body')
      .css('margin-right', '')
      .removeClass('showing-modal');
    $modal.hide();
};

// I prefer to generate and dynamically insert the modal
// but for this demonstration it is already in the markup.
var $modal = $('#modal');

// Clicking outside the inner modal content should close it.
$modal
	.click(function () {
		closeModal($modal);
	})
  .find('.modal-inner').click(function (event) {
  	event.stopPropagation();
	});

// Open the modal when open button is pressed.
$('#open').click(function (event) {
  event.preventDefault();
  openModal($modal);
});

*/